import React from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Paper,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DescriptionIcon from "@mui/icons-material/Description";
import LanguageIcon from "@mui/icons-material/Language";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { styled } from "@mui/material/styles";

// Custom styled components
const SectionTitle = styled(Typography)(({ theme }) => ({
  position: "relative",
  fontWeight: 700,
  marginBottom: theme.spacing(6),
  paddingBottom: theme.spacing(2),
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "80px",
    height: "4px",
    backgroundColor: "#C10E14",
  },
}));
const StepIcon = styled(Box)(({ theme }) => ({
  backgroundColor: "#C10E14", // Orange color from the image
  borderRadius: "50%",
  width: 70,
  height: 70,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  marginBottom: theme.spacing(2),
}));

const StepNumber = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  fontSize: "0.75rem",
  letterSpacing: 1,
  marginBottom: theme.spacing(1),
}));

const StepTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

const StepDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.6,
}));

export default function HowItWorks() {
  // Step data
  const steps = [
    {
      number: "Step 1",
      title: "Valuation Visit",
      description:
        "Property valuation within 24 hours, backed by data-driven analysis.",
      icon: <AssessmentIcon sx={{ fontSize: 30 }} />,
    },
    {
      number: "Step 2",
      title: "Paper Signing",
      description:
        "Homeowner's consent to property listing: all essential papers are executed and submitted for listing.",
      icon: <DescriptionIcon sx={{ fontSize: 30 }} />,
    },
    {
      number: "Step 3",
      title: "Global Reach",
      description:
        "Now sit back while our marketing team lists your property on top Dubai property portals.",
      icon: <LanguageIcon sx={{ fontSize: 30 }} />,
    },
    {
      number: "Step 4",
      title: "Return on Investments",
      description:
        "Experience the convenience of receiving your investment returns from the comfort of your home.",
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 30 }} />,
    },
  ];

  return (
    <Container sx={{ py: 6 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <SectionTitle variant="h4" component="h2">
          How does it work?
        </SectionTitle>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: "900px", mx: "auto", lineHeight: 1.8 }}
        >
          Start the effortless journey of listing your property with us, step by
          step.
        </Typography>
      </Box>

      {/* Steps Grid */}
      <Grid container spacing={3}>
        {steps.map((step, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                borderRadius: 2,
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  p: 3,
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <StepIcon>{step.icon}</StepIcon>
                  <StepNumber>{step.number}</StepNumber>
                  <StepTitle variant="h6">{step.title}</StepTitle>
                  <StepDescription variant="body2">
                    {step.description}
                  </StepDescription>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
